import React from 'react'

import LabelBarChart from 'components/shared/charts/label-bar-chart'
import { Answers } from 'providers/context/do-tolc-simulation-context'
import { cn } from 'lib/utils'

export const getDataFromStatsAnswers = (stats: FormatDataStatsAnswers) => {
    return [
        {
            label: 'correct',
            value: stats.correct,
            fill: 'success',
        },
        {
            label: 'skipped',
            value: stats.skipped,
            fill: 'warning',
        },
        {
            label: 'wrong',
            value: stats.wrong,
            fill: 'error',
        },
    ]
}

export const getStatsFromTest = (test: Test): FormatDataStatsAnswers => {
    const out: FormatDataStatsAnswers = {
        correct: 0,
        wrong: 0,
        skipped: 0,
    }
    test.questions.forEach((v) => {
        if (v.answer_status === 'CORRECT') {
            out.correct += 1
        } else if (v.answer_status === 'SKIPPED') {
            out.skipped += 1
        } else if (v.answer_status === 'WRONG') {
            out.wrong += 1
        }
    })
    return out
}

export const getDataFromTest = (test: Test): DataBarChart[] => {
    if (test.status === 'IN_PROGRESS' && test.stats) {
        const done = test.questions_number - test.stats.skipped
        const todo = test.stats.skipped
        return [
            {
                label: 'done',
                value: done,
                fill: 'primary',
            },
            {
                label: 'notDone',
                value: todo,
                fill: 'accent',
            },
        ]
    } else {
        return getDataFromStatsAnswers(test.stats !== undefined ? test.stats : getStatsFromTest(test))
    }
}

export default function SectionBarChart(props: PropsSectionBarChart) {
    const getAnswersDone = (answers: Answers, totalQuestions: number): DataBarChart[] => {
        const done = Object.keys(answers).length
        const todo = totalQuestions - done
        return [
            {
                label: 'done',
                value: done || 0,
                fill: 'primary',
            },
            {
                label: 'notDone',
                value: todo,
                fill: 'accent',
            },
        ]
    }
    const data = React.useMemo(() => {
        if (props.test && !props.dataFromState) {
            return getDataFromTest(props.test)
        } else if (props.stats_answers) {
            return getDataFromStatsAnswers(props.stats_answers)
        } else if (props.dataFromState && props.test) {
            return getAnswersDone(props.dataFromState.answers, props.test.questions_number)
        } else {
            return []
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.test, props.stats_answers, props.dataFromState])

    const sumValues = React.useMemo(() => data.map((v) => v.value).reduce((prev, curr) => prev + curr, 0), [data])
    const fill = React.useCallback((color: string) => `bg-${color}`, [])

    return (
        <div className="py-2 flex flex-col items-center">
            <div className="flex gap-2">
                {data.map((v) => (
                    <LabelBarChart key={v.label} v={v} />
                ))}
            </div>

            <div className="flex p-2 w-full">
                <div className="flex-1 flex rounded-md overflow-hidden">
                    {data.map((v) => {
                        const val = ((v.value / sumValues) * 100).toString() + '%'
                        return (
                            <div style={{ flex: val }} key={props.test?._id + v.label}>
                                <div className={cn(`h-[22px] bg-warning`, fill(v.fill))} />
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}
